export const CAREER = [
  {
    id: "informationSystemControl2024",
    jobTitleKey: "careerPage.jobs.informationSystemControl2024.jobTitle",
    datesKey: "careerPage.jobs.informationSystemControl2024.dates",
    durationKey: "careerPage.jobs.informationSystemControl2024.duration",
    locationKey: "careerPage.jobs.informationSystemControl2024.location",
    descriptionKeys: [
      "careerPage.jobs.informationSystemControl2024.description.0",
      "careerPage.jobs.informationSystemControl2024.description.1",
      "careerPage.jobs.informationSystemControl2024.description.2",
    ],
    skillsKeys: ["rigor", "organizationalSkills", "teamwork", "qualityControl", "adaptability"],
  },
  {
    id: "fullStackMERN2024",
    jobTitleKey: "careerPage.jobs.fullStackMERN2024.jobTitle",
    datesKey: "careerPage.jobs.fullStackMERN2024.dates",
    durationKey: "careerPage.jobs.fullStackMERN2024.duration",
    locationKey: "careerPage.jobs.fullStackMERN2024.location",
    descriptionKeys: ["careerPage.jobs.fullStackMERN2024.description.0"],
    skillsKeys: ["react", "express", "mongodb", "nodejs", "tailwind", "i18n", "framerMotion"],
  },
  {
    id: "frontendReactAzeon2023",
    jobTitleKey: "careerPage.jobs.frontendReactAzeon2023.jobTitle",
    datesKey: "careerPage.jobs.frontendReactAzeon2023.dates",
    durationKey: "careerPage.jobs.frontendReactAzeon2023.duration",
    locationKey: "careerPage.jobs.frontendReactAzeon2023.location",
    descriptionKeys: [
      "careerPage.jobs.frontendReactAzeon2023.description.0",
      "careerPage.jobs.frontendReactAzeon2023.description.1",
    ],
    skillsKeys: ["react", "javascript", "sass", "mui", "redux", "rtkQuery", "json"],
  },
  {
    id: "frontendReactOpenclassrooms2022",
    jobTitleKey: "careerPage.jobs.frontendReactOpenclassrooms2022.jobTitle",
    datesKey: "careerPage.jobs.frontendReactOpenclassrooms2022.dates",
    durationKey: "careerPage.jobs.frontendReactOpenclassrooms2022.duration",
    locationKey: "careerPage.jobs.frontendReactOpenclassrooms2022.location",
    descriptionKeys: ["careerPage.jobs.frontendReactOpenclassrooms2022.description.0"],
    skillsKeys: [
      "react",
      "javascript",
      "html",
      "css",
      "sass",
      "redux",
      "npm",
      "mui",
      "git",
      "github",
      "figma",
    ],
  },
  {
    id: "userSupportTechnician2013",
    jobTitleKey: "careerPage.jobs.userSupportTechnician2013.jobTitle",
    datesKey: "careerPage.jobs.userSupportTechnician2013.dates",
    durationKey: "careerPage.jobs.userSupportTechnician2013.duration",
    locationKey: "careerPage.jobs.userSupportTechnician2013.location",
    descriptionKeys: [
      "careerPage.jobs.userSupportTechnician2013.description.0",
      "careerPage.jobs.userSupportTechnician2013.description.1",
      "careerPage.jobs.userSupportTechnician2013.description.3",
      "careerPage.jobs.userSupportTechnician2013.description.4",
    ],
    skillsKeys: [
      "itDiagnostics",
      "pedagogy",
      "solutionImplementation",
      "communication",
      "hardwareAssistance",
      "softwareDeployment",
      "systemAdministration",
      "listeningSkills",
      "needsAnalysis",
      "supportAndTutoring",
    ],
  },
  {
    id: "expertReferent2008",
    jobTitleKey: "careerPage.jobs.expertReferent2008.jobTitle",
    datesKey: "careerPage.jobs.expertReferent2008.dates",
    durationKey: "careerPage.jobs.expertReferent2008.duration",
    locationKey: "careerPage.jobs.expertReferent2008.location",
    descriptionKeys: [
      "careerPage.jobs.expertReferent2008.description.0",
      "careerPage.jobs.expertReferent2008.description.1",
      "careerPage.jobs.expertReferent2008.description.2",
      "careerPage.jobs.expertReferent2008.description.3",
    ],
    skillsKeys: [
      "pedagogy",
      "solutionImplementation",
      "communication",
      "decisionMaking",
      "animationTechniques",
      "training",
      "changeManagement",
      "qualityControl",
      "listeningSkills",
      "processAnalysis",
      "needsAnalysis",
      "supportAndTutoring",
      "electronicArchiving",
    ],
  },
  {
    id: "advisorServiceOffers2005",
    jobTitleKey: "careerPage.jobs.advisorServiceOffers2005.jobTitle",
    datesKey: "careerPage.jobs.advisorServiceOffers2005.dates",
    durationKey: "careerPage.jobs.advisorServiceOffers2005.duration",
    locationKey: "careerPage.jobs.advisorServiceOffers2005.location",
    descriptionKeys: [
      "careerPage.jobs.advisorServiceOffers2005.description.0",
      "careerPage.jobs.advisorServiceOffers2005.description.1",
    ],
    skillsKeys: [
      "clientFollowUp",
      "solutionSales",
      "listeningSkills",
      "needsAnalysis",
      "supportAndTutoring",
    ],
  },
  {
    id: "accountManager2001",
    jobTitleKey: "careerPage.jobs.accountManager2001.jobTitle",
    datesKey: "careerPage.jobs.accountManager2001.dates",
    durationKey: "careerPage.jobs.accountManager2001.duration",
    locationKey: "careerPage.jobs.accountManager2001.location",
    descriptionKeys: [
      "careerPage.jobs.accountManager2001.description.0",
      "careerPage.jobs.accountManager2001.description.1",
    ],
    skillsKeys: [
      "pedagogy",
      "solutionImplementation",
      "legalAssistance",
      "organizationalSkills",
      "listeningSkills",
    ],
  },
]
